import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { ErrorStackService } from '../error-stack.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  email : string;
  password : string;
  showSpinner: boolean = false;

  constructor(private router: Router, 
              private authService: AuthService,
              private errorStack: ErrorStackService) { }

  ngOnInit() {
  }

  login() : void { 
    if(this.email !== '' && this.password !== ''){
       this.showSpinner = true;
       this.authService.login(this.email, this.password)
        .then(result => {
          this.showSpinner = false;
          this.router.navigate(["/"]); 
        }, error => {
          this.showSpinner = false;
          this.errorStack.append(error, true);
        })
       
      }
      else { 
        this.showSpinner = false;
        alert("Invalid credentials"); 
      } 
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts